export const NoDataForCountryPlaceholder = () => (
  <div className="w-max m-auto mt-10">
    <span className="text-gray-400">No data for this country.</span>
  </div>
);
